import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-221c48c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "proposal-content__sections__section" }
const _hoisted_2 = { class: "flex justify-end w-20" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "proposal-content__sections__section__content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_expand_button = _resolveComponent("expand-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "proposal-content__sections__section__title",
      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.expand = !_ctx.expand), ["exact"]))
    }, [
      _createElementVNode("span", null, [
        _renderSlot(_ctx.$slots, "title", {}, undefined, true)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_expand_button, {
          class: "",
          modelValue: _ctx.expand,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.expand) = $event)),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.expand = !_ctx.expand))
        }, null, 8, ["modelValue"]),
        (_ctx.showRemoveButton && _ctx.isProposalEditable)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('removeSectionClick')), ["prevent"])),
              class: "ml-5 text-color-rejected"
            }, _hoisted_4))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.expand)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ]))
}